import React, { useState } from 'react';

import Tabs from '../../ui/Tabs/Tabs';
import type { PaymentMethodType } from '../../services/commonCheckout/types/SessionConfig/PaymentMethodConfig';
import IconRenderer from '../../ui/Icons/IconRenderer';

const tabsConfig = [
  {
    id: 'cardTab',
    value: 'CARD',
    label: 'Card',

    icon: (
      <IconRenderer
        testId="tab-card-icon"
        name="card"
        size="large"
      />
    ),
  },
  {
    id: 'bankAccountTab',
    value: 'BANK_ACCOUNT',
    label: 'Bank',

    icon: (
      <IconRenderer
        testId="tab-bank-account-icon"
        name="bank"
        size="large"
      />
    ),
  },
];

type PaymentMethodTabSelectorProps = {
  availablePaymentMethodTypes: PaymentMethodType[];
  onTabSelectionChange: (
    selectedPaymentMethodType: PaymentMethodType,
  ) => void;
};

const PaymentMethodTabSelector = ({
  availablePaymentMethodTypes,
  onTabSelectionChange,
}: PaymentMethodTabSelectorProps) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const filteredTabsConfig = tabsConfig.filter((tab) =>
    availablePaymentMethodTypes?.includes(
      tab.value as PaymentMethodType,
    ),
  );

  const handleTabSelectionChange = (index: number) => {
    setSelectedIndex(index);
    onTabSelectionChange(
      filteredTabsConfig[index].value as PaymentMethodType,
    );
  };

  return (
    <Tabs
      tabsConfig={filteredTabsConfig}
      onTabSelectionChange={handleTabSelectionChange}
      selectedIndex={selectedIndex}
    />
  );
};

export default PaymentMethodTabSelector;
